import {
  INDETERMINATE_PROGRESS_HIDE,
  INDETERMINATE_PROGRESS_SHOW
} from "./constants";

export default {
  [INDETERMINATE_PROGRESS_SHOW](state, description) {
    state.showIndeterminateLoading = true;
    state.descriptionText = description;
  },
  [INDETERMINATE_PROGRESS_HIDE](state, description) {
    state.showIndeterminateLoading = false;
    state.descriptionText = description;
  }
};
